import React, { useState, useEffect, useMemo, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import 'react-datepicker/dist/react-datepicker.css';
import useApi from '../../api/useApi';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { NumericFormat } from 'react-number-format';
import DatePicker from 'react-datepicker';
import Moment from 'react-moment';//Both are required here
import Modal from 'react-bootstrap/Modal';
import Dropdown from 'react-bootstrap/Dropdown';
//import 'bootstrap/dist/css/bootstrap.min.css'; // Import Bootstrap CSS
import '../../custom.css';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import setSeconds from 'date-fns/setSeconds';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const MonthlyAuctionReport = () => {
    const [reportData, setReportData] = useState([]);
    const [gridApi, setGridApi] = useState(null);
    const gridRef = useRef(null);
    const [selectedRow, setSelectedRow] = useState({});
    const [modalVisible, setModalVisible] = useState(false);
    const [companies, setCompanies] = useState([]);
    const [companyId, setCompanyId] = useState(0);
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const api = useApi();
    const navigate = useNavigate();

    const loadCompanies = async () => {
        try {
            const lotData = await api.getCompaniesDropdown();
            setCompanies(lotData);
        } catch (error) {
            alert('Unable to fetch companies data.');
        }
    };

    const loadReport = async () => {
        const params = {
            companyId: parseInt(companyId),
            fromDate: fromDate,
            toDate: toDate
        }
        await api.getReport('MonthlyAuction', params).then((data) => {
            setReportData(data);
        })
    }

    useEffect(() => {
        loadCompanies();
        loadReport();
    }, []);

    const dateRenderer = (props, format) => {
        const cellValue = props.valueFormatted ? props.valueFormatted : props.value;
        return (
            <span>
                <span>{cellValue ? <Moment format={format}>{cellValue}</Moment> : null}</span>
            </span>
        );
    };

    const viewSummaryReport = () => {
        setModalVisible(true);
    };

    useEffect(() => {
        if (gridRef.current.api) {
            if (reportData.length === 0) {
                gridRef.current.api.showNoRowsOverlay();
            } else {
                gridRef.current.api.hideOverlay();
            }
        }
    }, [gridRef, reportData]);

    //const downloadCSRReport = async (e) => {
    //    e.preventDefault();
    //    try {
    //        const { fileName, fileData } = await api.downloadReport('CSR', selectedRow.AuctionId);
    //        const url = window.URL.createObjectURL(new Blob([fileData]), { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    //        const link = document.createElement('a');
    //        link.href = url;
    //        link.setAttribute('download', fileName);
    //        document.body.appendChild(link);
    //        link.click();
    //    } catch (error) {
    //        alert('Unable to download file.');
    //    }
    //}

    const handleClose = () => {
        setModalVisible(false);
    };

    const qtyRenderer = (props) => {
        const cellValue = props.valueFormatted ? props.valueFormatted : props.value;
        return (
            <span>
                <span><NumericFormat suffix={' Kg'} displayType="text" value={cellValue} allowLeadingZeros thousandSeparator="," decimalScale={2} /> </span>
            </span>
        );
    };

    const amountRenderer = (props) => {
        const cellValue = props.valueFormatted ? props.valueFormatted : props.value;
        return (
            <span>
                <span><NumericFormat prefix={'₹ '} displayType="text" value={cellValue} allowLeadingZeros thousandSeparator="," decimalScale={2} /> </span>
            </span>
        );
    };

    const columns = [
        { headerName: 'Auction Date', field: 'AuctionDate', headerClass: 'text-center', cellClass: 'text-center', width: 100, cellRenderer: (props) => dateRenderer(props, 'DD-MMM-YYYY') },
        { headerName: 'Auctioneer', field: 'CompanyName', headerClass: 'text-center', width: 200, },
        { headerName: 'Auction Code', field: 'AuctionCode', headerClass: 'text-center', cellClass: 'text-center', width: 200, },
        { headerName: 'Auction Center', field: 'Center', headerClass: 'text-center', cellClass: 'text-center', width: 200 },
        { headerName: 'Auction Qty (Kgs)', field: 'TotalQty', cellClass: 'text-center', width: 100 },
        { headerName: 'Sold Qty (Kgs)', field: 'TotalSoldQty', cellClass: 'text-center', width: 100 },
        { headerName: 'Auction Value (Rs)', field: 'AuctionValue', cellClass: 'text-center', width: 150, cellRenderer: amountRenderer },
        { headerName: 'Min Price (Rs)', field: 'MinPrice', cellClass: 'text-center', width: 100, cellRenderer: amountRenderer },
        { headerName: 'Max Price (Rs)', field: 'MaxPrice', cellClass: 'text-center', width: 100, cellRenderer: amountRenderer },
        { headerName: 'Average Price (Rs)', field: 'AuctionAvg', cellClass: 'text-center', width: 100, cellRenderer: amountRenderer },
        { headerName: 'Crop Year', field: 'CropYear', cellClass: 'text-center', width: 100 },
        { headerName: 'Crop Month', cellClass: 'text-center', field: 'CropMonth', width: 100 },
        { headerName: 'Total Lots', cellClass: 'text-center', field: 'TotalLots', width: 100 },
        { headerName: 'Remark', cellClass: 'text-center', field: 'Remark', width: 100 },

    ];

    const gridOptions = {
        defaultColDef: {
            wrapHeaderText: true,
            autoHeaderHeight: true,
            sortable: false,
        },
        rowSelection: 'single',
        suppressRowClickSelection: true,
        columnDefs: columns,
        rowClass: 'custom-grid-font',

        getRowClass: params => {
            if (params.node.rowIndex % 2 === 0) {
                return 'bg-gray-50-i';
            }
        }
    };
    const noRowsOverlayComponent = useMemo(() => { return CustomNoRowsOverlay }, []);
    const noRowsOverlayComponentParams = useMemo(() => {
        return {
            noRowsMessageFunc: () => 'No rows found at: ' + new Date().toLocaleTimeString(),
        }
    }, []);

    const onGridReady = (params) => {
        setGridApi(params.api);
    };

    const handleTraderChange = (event) => {
        setCompanyId(event.target.value);
        setReportData([]);
    };

    const handleFromDateChange = (_fromDate) => {
        setFromDate(_fromDate);
        setReportData([]);
    };

    const handleToDateChange = (_toDate) => {
        setToDate(_toDate);
        setReportData([]);
    };

    const handleOnSearchReport = () => {
        loadReport();
    }

    const exportToExcel = async (e) => {
        debugger
        e.preventDefault();
        const params = {
            companyId: parseInt(companyId),
            fromDate: fromDate,
            toDate: toDate
        }
        try {
            const { fileName, fileData } = await api.downloadMonthlyAuctionReport('MonthlyAuction', params);
            const url = window.URL.createObjectURL(new Blob([fileData]), { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();

        } catch (error) {
            alert('Unable to download file.');
        }
    };

    return (
        <div className="inner-body">
            <div className="page-header">
                <div>
                    <h2 className="main-content-title tx-24 mg-b-5">Monthly Auction Report</h2>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                            <a className="custom-link" onClick={() => navigate('/home')}>Home</a></li>
                        <li className="breadcrumb-item active" aria-current="page">Monthly Auction Report</li>
                    </ol>
                </div>
                <div className="d-flex">
                    <div className="justify-content-center">
                        {/*<button className="btn ripple btn-outline-danger pd-x-10 mg-r-10 btn-sm" type="button" onClick={exportToPdf}>*/}
                        {/*    <i class="ti ti-import me-2"></i>Export to pdf*/}
                        {/*</button>*/}
                        {/*<button className="btn ripple btn-outline-primary pd-x-10 mg-r-5 btn-sm" type="button" onClick={exportToExcel}>*/}
                        {/*    <i class="ti ti-import me-2"></i>Export to csv*/}
                        {/*</button>*/}
                    </div>
                </div>
            </div>
            <div className="row row-sm">
                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 grid-margin">
                    <div className="card custom-card">
                        <div className="card-body">
                            <div className="d-flex justify-content-between mg-b-8">
                                <div>
                                    <div className="d-flex mg-t-4">
                                        <div className="col-4">
                                            Auctioneer Name :
                                            <select
                                                className="form-control select2-show-search select2-dropdown select2-hidden-accessible"
                                                tabIndex="-1"
                                                aria-hidden="true"
                                                value={companyId}
                                                onChange={handleTraderChange}
                                            >
                                                <option label="--All Auctioneers--"></option>
                                                {companies.map(t => {
                                                    return <option value={t.companyId}>{t.companyName}</option>
                                                })}
                                            </select>
                                        </div>
                                        <div className="col-2">
                                            From Date :
                                            <DatePicker className="form-control" dateFormat='dd-MMM-yyyy' selected={fromDate} onChange={handleFromDateChange} />
                                        </div>
                                        <div className="col-2">
                                            To Date :
                                            <DatePicker className="form-control" dateFormat='dd-MMM-yyyy' selected={toDate} onChange={handleToDateChange} />

                                        </div>

                                        <div className="col-1">
                                            <button className="btn mt-4 ripple btn-outline-primary pd-x-10 mg-r-5 btn-sm" type="button" onClick={handleOnSearchReport}>
                                                <i class="ti ti-search me-2"></i>Search
                                            </button>
                                        </div>
                                        <div className="col-2">
                                            <button className="btn mt-4  ripple btn-outline-primary pd-x-10 mg-r-5 btn-sm" type="button" onClick={(e) => exportToExcel(e)} >
                                                <i class="ti ti-import me-2"></i>Export to excel
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                </div>
                            </div>
                            <div
                                style={{ height: 500 }}
                                className={
                                    "ag-theme-alpine mt-4 showscroll"
                                }
                            >
                                <AgGridReact
                                    ref={gridRef}
                                    rowHeight={36}
                                    gridOptions={gridOptions}
                                    rowData={reportData}
                                    onGridReady={onGridReady}
                                    noRowsOverlayComponent={noRowsOverlayComponent}
                                    noRowsOverlayComponentParams={noRowsOverlayComponentParams}
                                    reactiveCustomComponents
                                />
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            {/*size='lg'*/}
            <Modal show={modalVisible} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Auction Summary</Modal.Title>
                </Modal.Header>
                <Modal.Body className="pd-x-40">
                    <div className="row">
                        <table className="table">
                            <tbody >
                                <tr className="border-bottom pd-4">
                                    <th>Auction Id : </th>
                                    <td>{selectedRow?.AuctionId}</td>
                                </tr>
                                <tr className="border-bottom ">
                                    <th>Auctioneer Name : </th>
                                    <td>{selectedRow?.CompanyName}</td>
                                </tr>
                                <tr className="border-bottom">
                                    <th>Auction Number : </th>
                                    <td>{selectedRow?.AuctionNo}</td>
                                </tr>
                                <tr className="border-bottom">
                                    <th>Total Lots : </th>
                                    <td>{selectedRow?.TotalLots}</td>
                                </tr>
                                <tr className="border-bottom">
                                    <th>Total Quantity : </th>
                                    <td>{selectedRow?.TotalArrivals}</td>
                                </tr>
                                <tr className="border-bottom">
                                    <th>Total Sold Quantity :</th>
                                    <td>{selectedRow?.TotalSales}</td>
                                </tr>
                                <tr className="border-bottom">
                                    <th>Total Sell Value : </th>
                                    <td>{selectedRow?.TotalSaleValue}</td>
                                </tr>
                                <tr className="border-bottom">
                                    <th>Total Bids :</th>
                                    <td>{selectedRow?.TotalBids}</td>
                                </tr>
                                <tr className="border-bottom">
                                    <th>Total Bidders :</th>
                                    <td>{selectedRow?.TotalBidders}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                </Modal.Body>
            </Modal>
        </div>
    );
};

export default MonthlyAuctionReport;


const CustomNoRowsOverlay = () => {
    return (
        <div role="presentation"  >
            <p>-No records available-</p>
            <p>Click Search to view result. </p>
        </div>
    );
};